import * as React from 'react';

function SvgLn(props) {
    return (
        <svg width={34} height={33} viewBox="0 0 34 33" {...props}>
            <path
                d="M7.16 4.328c0 1.884-1.509 3.41-3.371 3.41S.418 6.213.418 4.329c0-1.883 1.509-3.411 3.37-3.411 1.863 0 3.372 1.528 3.372 3.41zm.027 6.14H.39v21.831h6.797V10.468zm10.85 0h-6.753v21.831h6.755V20.84c0-6.372 8.196-6.893 8.196 0v11.46h6.78V18.476c0-10.752-12.128-10.36-14.977-5.068v-2.94z"
                fillRule="nonzero"
            />
        </svg>
    );
}

export default SvgLn;
